import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { authorizationCode } from "./schema/oauth/authorizationCode";
import { getLinkedMerchantPhone } from "./schema/person/get-linked-merchant-phone";
import { setMarketingSmsConsent } from "./schema/person/set-marketing-sms-consent";
import { setOperationalSmsConsent } from "./schema/person/set-operational-sms-consent";
import { startLinkMerchantPhone } from "./schema/person/start-link-merchant-phone";
import { unlinkMerchantPhone } from "./schema/person/unlink-merchant-phone";
import { verifyLinkMerchantPhone } from "./schema/person/verify-link-merchant-phone";
import { approveTeamAccess } from "./schema/team-access/approveTeamAccess";
import { exchangeTeamAccessCode } from "./schema/team-access/exchangeTeamAccessCode";
import { getTeamAccessRequest } from "./schema/team-access/getTeamAccessRequest";
import { revokeTeamAccessKey } from "./schema/team-access/revokeTeamAccessKey";

const merchantPersonPhone = {
  getLinkedMerchantPhone,
  setMarketingSmsConsent,
  setOperationalSmsConsent,
  startLinkMerchantPhone,
  unlinkMerchantPhone,
  verifyLinkMerchantPhone,
};

/** A pre-registered app (Ditto) signing a store admin in for a store API key. */
const teamAccess = {
  approveTeamAccess,
  exchangeTeamAccessCode,
  getTeamAccessRequest,
  revokeTeamAccessKey,
};

export const rpcDefinition = {
  authorizationCode,
  ...merchantPersonPhone,
  ...teamAccess,
};

export type RedoAuthRpcDefinition = InferRpcDefinition<typeof rpcDefinition>;
